import React from "react";
import { Link } from "react-router-dom";
import "./LdsCustomerQuoteLegalSection.scss";
import {
  IoInformationCircleOutline,
  IoShieldCheckmarkOutline,
} from "react-icons/io5";
import AdditionalInfo from "./AdditionalInfo";

/**
 * מידע נוסף + גילוי נאות + קישור לתקנון — זהה לעמוד פרטי חבילה (סוכן),
 * לשימוש בהצעת מחיר אישית (?offer=1) וכד׳.
 */
export default function LdsCustomerQuoteLegalSection({
  additionalInfoHtml = "",
  className = "",
  termsLinkClassName = "",
  /** false = עמוד סוכן (ללא שינוי UI מעבר למה שהיה) */
  showFullTermsLink = true,
  /** "flight" — כותרות משנה וניסוח בולט אחד מותאמים לטיסות (לא חבילה/מלון) */
  variant = "default",
}) {
  const raw = additionalInfoHtml;
  const hasAdditional =
    raw != null &&
    raw !== "" &&
    raw !== 0 &&
    String(raw).replace(/<[^>]*>/g, "").trim().length > 0;

  const isFlight = variant === "flight";
  const additionalSubtitle = isFlight
    ? "מידע נוסף וחשוב על הטיסה וההצעה"
    : "מידע נוסף וחשוב על החבילה";
  const inaccuracyLine = isFlight
    ? "ייתכנו אי־דיוקים במידע המוצג."
    : "ייתכנו אי־דיוקים במידע ובתמונות.";

  return (
    <div className={`lds-customer-quote-legal ${className}`.trim()}>
      {hasAdditional ? (
        <div className="data-box additional-info-modern">
          <div className="data-box-header-modern">
            <div className="data-box-header-icon-wrapper additional">
              <IoInformationCircleOutline className="header-icon-modern" />
            </div>
            <div className="data-box-header-content">
              <h3 className="data-box-header-title">מידע נוסף</h3>
              <p className="data-box-header-subtitle">
                {additionalSubtitle}
              </p>
            </div>
          </div>
          <div className="data-box-body-modern">
            <AdditionalInfo innerHtml={raw} />
          </div>
        </div>
      ) : null}

      <div className="data-box disclosure-notice-modern">
        <div className="data-box-header-modern">
          <div className="data-box-header-icon-wrapper disclosure">
            <IoShieldCheckmarkOutline className="header-icon-modern" />
          </div>
          <div className="data-box-header-content">
            <h3 className="data-box-header-title">גילוי נאות</h3>
            <p className="data-box-header-subtitle">
              מידע חשוב ותנאים שחשוב להכיר
            </p>
          </div>
        </div>
        <div className="data-box-body-modern disclosure-content">
          <div className="passangerData-disclosure-notice-content">
            <div className="passangerData-disclosure-notice-item">
              <strong>•</strong> שינוי או ביטול הזמנה כרוכים בדמי טיפול של החברה
              בסך 85$ לנוסע, בנוסף לדמי הביטול של הספק.
            </div>
            <div className="passangerData-disclosure-notice-item">
              <strong>•</strong> המחיר והזמינות סופיים רק לאחר אישור הספק ושובר.
            </div>
            <div className="passangerData-disclosure-notice-item">
              <strong>•</strong> תנאי הביטול והשינוי נקבעים בלעדית על ידי הספק
              ועלולים לכלול חיובים מלאים.
            </div>
            <div className="passangerData-disclosure-notice-item">
              <strong>•</strong> {inaccuracyLine}
            </div>
            <div className="passangerData-disclosure-notice-item">
              <strong>•</strong> הסוכן מחויב להעביר ללקוח את כל תנאי ההזמנה בצורה
              מלאה וברורה.
            </div>
          </div>
        </div>
      </div>

      {showFullTermsLink ? (
        <p className={`lds-customer-quote-legal__terms ${termsLinkClassName}`.trim()}>
          <Link to="/termsAndConditions" className="lds-customer-quote-legal__terms-link">
            תקנון מלא
          </Link>
        </p>
      ) : null}
    </div>
  );
}
